// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.REj8Z6 {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--spacing-1-5);
  padding: var(--spacing-2);
  border-radius: var(--radius-s);
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  background-color: var(--surface-neutral-pale);
  width: 100%;
}

.N19xuS {
  padding-right: 96px;
}

.VOSjIe {
  display: flex;
  align-items: center;
  gap: var(--spacing-1-5);
  flex: 1;
  min-width: 0;
  padding: 0;
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: inherit;
  text-align: left;
  cursor: inherit;
  width: 100%;
}

.VOSjIe:focus {
  outline: 2px solid var(--surface-primary-medium);
  outline-offset: 2px;
}

.Hul0va {
  position: absolute;
  right: var(--spacing-2);
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  cursor: default;
}

.REj8Z6.kNSHhj {
  background-color: var(--surface-primary-subtle);
}

.REj8Z6:disabled,
.REj8Z6.ppeZGF {
  cursor: not-allowed;
  background-color: var(--surface-neutral-pale);
}

.REj8Z6:hover:not(.kNSHhj):not(.ppeZGF) {
  background-color: var(--surface-primary-subtle);
}

.Fe1STk {
  width: var(--spacing-2);
  height: var(--spacing-2);
  border: 1px solid var(--icon-neutral-dark);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: var(--spacing-0-5);
}

.kNSHhj .Fe1STk {
  border-color: var(--surface-primary-medium);
  background-color: var(--surface-primary-medium);
}

.c_qhUb {
  width: 6px;
  height: 6px;
  background-color: var(--surface-neutral-white);
  border-radius: 50%;
}

.ggbmLo {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.Ra6AZ8 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: 24px;
  color: var(--text-neutral-dark);
  margin: 0;
}

.ppeZGF .Ra6AZ8 {
  color: var(--disabled-subtle-text);
}

.zCwmpq {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  line-height: 16px;
  color: var(--text-neutral-dark);
  margin: 0;
}

.ppeZGF .zCwmpq {
  color: var(--disabled-subtle-text);
}

.ppeZGF .RcFxHz {
  opacity: 0.4;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/EmissorPaymentPage/components/EmissorPaymentMethodOption/EmissorPaymentMethodOption.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;EAEE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd","sourcesContent":[".paymentOption {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1-5);\n  padding: var(--spacing-2);\n  border-radius: var(--radius-s);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid transparent;\n  background-color: var(--surface-neutral-pale);\n  width: 100%;\n}\n\n.hasRecommendedTag {\n  padding-right: 96px;\n}\n\n.selectHit {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1-5);\n  flex: 1;\n  min-width: 0;\n  padding: 0;\n  border: none;\n  background: transparent;\n  font-family: inherit;\n  font-size: inherit;\n  text-align: left;\n  cursor: inherit;\n  width: 100%;\n}\n\n.selectHit:focus {\n  outline: 2px solid var(--surface-primary-medium);\n  outline-offset: 2px;\n}\n\n.recommendedTag {\n  position: absolute;\n  right: var(--spacing-2);\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1;\n  cursor: default;\n}\n\n.paymentOption.selected {\n  background-color: var(--surface-primary-subtle);\n}\n\n.paymentOption:disabled,\n.paymentOption.disabled {\n  cursor: not-allowed;\n  background-color: var(--surface-neutral-pale);\n}\n\n.paymentOption:hover:not(.selected):not(.disabled) {\n  background-color: var(--surface-primary-subtle);\n}\n\n.radioButton {\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n  border: 1px solid var(--icon-neutral-dark);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin: var(--spacing-0-5);\n}\n\n.selected .radioButton {\n  border-color: var(--surface-primary-medium);\n  background-color: var(--surface-primary-medium);\n}\n\n.radioSelected {\n  width: 6px;\n  height: 6px;\n  background-color: var(--surface-neutral-white);\n  border-radius: 50%;\n}\n\n.methodContent {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.methodTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: 24px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.disabled .methodTitle {\n  color: var(--disabled-subtle-text);\n}\n\n.methodDescription {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  line-height: 16px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.disabled .methodDescription {\n  color: var(--disabled-subtle-text);\n}\n\n.disabled .methodIcon {\n  opacity: 0.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paymentOption": `REj8Z6`,
	"hasRecommendedTag": `N19xuS`,
	"selectHit": `VOSjIe`,
	"recommendedTag": `Hul0va`,
	"selected": `kNSHhj`,
	"disabled": `ppeZGF`,
	"radioButton": `Fe1STk`,
	"radioSelected": `c_qhUb`,
	"methodContent": `ggbmLo`,
	"methodTitle": `Ra6AZ8`,
	"methodDescription": `zCwmpq`,
	"methodIcon": `RcFxHz`
};
module.exports = ___CSS_LOADER_EXPORT___;
